export default __webpack_public_path__ + "static/media/loader.8f49a69e.svg";